// extracted by mini-css-extract-plugin
module.exports = {"spinner":"RXRPc","rotator":"_2bs6O","path":"GsHm5","dash":"_3pGIj"};